import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { CheckCircle, ArrowLeft, Mail } from 'lucide-react';
import { Button } from '../components/ui/button';

const Gracias = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-16 px-6">
      <Helmet>
        <title>¡Gracias por Contactarnos! | Sinergia Empresarial CSCE</title>
        <meta name="description" content="Hemos recibido tu solicitud. Nuestro equipo te contactará pronto para agendar tu consulta inicial." />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="max-w-2xl w-full">
        <div className="bg-white rounded-lg shadow-xl p-12 text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-green-100 rounded-full mb-6">
            <CheckCircle className="w-12 h-12 text-sinergia-verde-claro" />
          </div>

          <h1 className="heading-1 text-4xl font-bold mb-4 text-sinergia-gris-oscuro">
            ¡Gracias por contactarnos!
          </h1>

          <p className="body-large text-gray-700 mb-6">
            Hemos recibido tu solicitud correctamente y la estamos revisando.
          </p>

          <div className="bg-gray-50 border border-sinergia-gris-claro rounded-lg p-6 mb-8">
            <h2 className="heading-4 text-xl font-semibold mb-3 text-sinergia-gris-oscuro">
              ¿Qué sigue?
            </h2>
            <ul className="space-y-3 text-left body-medium text-gray-700">
              <li className="flex items-start">
                <span className="flex-shrink-0 w-6 h-6 bg-sinergia-azul text-white rounded-full flex items-center justify-center mr-3 mt-0.5 text-sm font-semibold">
                  1
                </span>
                <span>Nuestro equipo revisará tu información en las próximas horas</span>
              </li>
              <li className="flex items-start">
                <span className="flex-shrink-0 w-6 h-6 bg-sinergia-azul text-white rounded-full flex items-center justify-center mr-3 mt-0.5 text-sm font-semibold">
                  2
                </span>
                <span>Te contactaremos en horario laboral (Lun-Vie, 8:00 AM - 5:00 PM)</span>
              </li>
              <li className="flex items-start">
                <span className="flex-shrink-0 w-6 h-6 bg-sinergia-azul text-white rounded-full flex items-center justify-center mr-3 mt-0.5 text-sm font-semibold">
                  3
                </span>
                <span>Agendaremos tu consulta inicial sin compromiso</span>
              </li>
            </ul>
          </div>

          <div className="flex items-center justify-center text-gray-600 mb-8">
            <Mail className="w-5 h-5 mr-2" />
            <p className="body-small">
              También recibirás un correo de confirmación
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/">
              <Button className="btn-primary px-8 py-3">
                <ArrowLeft className="mr-2 w-5 h-5" />
                Volver al inicio
              </Button>
            </Link>
            <Link to="/servicios">
              <Button variant="outline" className="btn-secondary px-8 py-3">
                Conocer más servicios
              </Button>
            </Link>
          </div>
        </div>

        <div className="mt-8 text-center">
          <p className="body-small text-gray-600">
            ¿Necesitas ayuda inmediata?{' '}
            <a href="mailto:contacto@sinergiaempresarialcsce.com" className="text-sinergia-azul hover:underline font-semibold">
              Escríbenos directamente
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Gracias;
